import { render, staticRenderFns } from "./DataAnalysisModel.vue?vue&type=template&id=25596710&scoped=true&"
import script from "./DataAnalysisModel.vue?vue&type=script&lang=js&"
export * from "./DataAnalysisModel.vue?vue&type=script&lang=js&"
import style0 from "./DataAnalysisModel.vue?vue&type=style&index=0&id=25596710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25596710",
  null
  
)

export default component.exports